import { render } from "./navbar-component.vue?vue&type=template&id=56e28ec8"
import script from "./navbar-component.vue?vue&type=script&lang=js"
export * from "./navbar-component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/coreslicer-git/coreslicer2/homepage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__